

















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({ components: {} })
export default class CBlock extends Vue {
  @Prop() blockHeader!: string;
  @Prop() count!: number;
  @Prop({ default: false }) twoColumn!: boolean;
  @Prop({ default: false }) isAllowToHide!: boolean;
  @Prop({ default: false }) isAllowToCreate!: boolean;
  @Prop({ default: false }) isHideHeader!: boolean;
  @Prop({ default: true }) isRoundTopCorner!: boolean;
  @Prop({ default: true }) isShown!: boolean;
  @Prop({ default: false }) req!: boolean;
  localIsShown!: boolean;

  data() {
    return {
      localIsShown: this.isShown
    };
  }

  @Watch("isShown")
  checkIsShown() {
    this.localIsShown = this.isShown;
  }
}
